document.addEventListener("DOMContentLoaded", (event) => {
Fancybox.bind("[data-fancybox]", {
    // Your custom options
    'width'				: '75%',
    'height'			: '75%',
    'autoScale'     	: false,
    'transitionIn'		: 'none',
    'transitionOut'		: 'none',
    'type'				: 'iframe'
    });
});